const CAP_MINERIA_BITCOIN = {
  "id": 145,
  "title": "La Minería de Bitcoin",
  "slug": "la-mineria-de-bitcoin",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "preview": "La minería de Bitcoin es un proceso digital que utiliza potencia computacional para validar transacciones, generar nuevos bloques y poner bitcoin en circulación.",
  "sections": [
    {
      "heading": "¿Qué es minar Bitcoin?",
      "text": [
        "La minería de Bitcoin es el proceso digital mediante el cual se validan transacciones, se aseguran los bloques y se crean nuevos bitcoin.",
        "Al igual que en la minería tradicional de oro, donde se remueve tierra para obtener metal valioso, en Bitcoin se utilizan máquinas especializadas que realizan cálculos computacionales para obtener una recompensa.",
        "Los mineros reciben dos tipos de incentivos:"
      ],
      "list": [
        "**Nuevos bitcoin** que se ponen en circulación",
        "**Comisiones** de todas las transacciones incluidas en el bloque"
      ],
      "notes": [
        "La minería también protege la red contra ataques, falsificaciones y doble gasto."
      ],
      "image": "mineria_equipo_digital_vs_oro.png"
    },
    {
      "heading": "¿Cómo funciona el desafío matemático?",
      "text": [
        "Cada 10 minutos aproximadamente, la red Bitcoin presenta un reto matemático que debe ser resuelto. Este reto consiste en encontrar un **hash válido** que cumpla con ciertas condiciones.",
        "El primer minero que lo resuelve:"
      ],
      "list": [
        "Genera un **nuevo bloque**",
        "Recibe la **recompensa en bitcoin** + comisiones",
        "Transmite el bloque al resto de nodos para su verificación"
      ],
      "notes": [
        "La cadena más larga no solo sirve como prueba de la secuencia de eventos, sino como prueba de que proviene del mayor conjunto de potencia de CPU.",
        "Satoshi Nakamoto – Whitepaper de Bitcoin"
      ]
    },
    {
      "heading": "Función principal de la minería",
      "text": [
        "La minería es esencial para que Bitcoin funcione como un sistema descentralizado y sin control central.",
        "Su objetivo principal es **evitar que alguien pueda gastar dos veces los mismos bitcoin o crear monedas falsas**.",
        "Los mineros revisan transacciones, las agrupan en bloques y aseguran el libro mayor o ledger de Bitcoin."
      ],
      "bluepoints": [
        "Evita el **doble gasto**",
        "Asegura que no existan **bitcoin falsos**",
        "Mantiene el **libro de contabilidad global** (blockchain)"
      ],

    },
    {
      "heading": "¿Qué es un pool de minería?",
      "text": [
        "Minar solo puede ser poco eficiente debido a la competencia y la dificultad.",
        "Por eso surgen las **pools de minería**, que son grupos de mineros que unen su poder computacional para aumentar sus posibilidades de resolver un bloque.",
        "Cuando el grupo obtiene una recompensa, se reparte proporcionalmente entre los participantes."
      ],
      "notes": [
        "Los pools hacen que la minería sea más justa y accesible."
      ],

    },
    {
      "heading": "¿Qué necesito para minar Bitcoin?",
      "text": [
        "En los inicios de Bitcoin, se podía minar con cualquier computadora normal usando CPU o GPU.",
        "Hoy, la competencia y la dificultad aumentaron tanto que se requieren equipos especializados llamados **ASIC**.",
        "Los ASIC están diseñados para **resolver hashes de forma extremadamente eficiente**."
      ],
      "list": [
        "CPU (procesadores) — solo viable en 2009",
        "GPU (tarjetas gráficas) — mayor potencia pero ya obsoletas",
        "**ASIC (equipos especializados)** — los más usados hoy en día"
      ],
      "notes": [
        "Los ASIC pueden costar desde cientos hasta miles de dólares según su potencia."
      ],
      "image": "evolucion_hardware_mineria.png"
    },
    {
      "heading": "Dificultad y Hash Rate",
      "text": [
        "La **dificultad** mide lo difícil que es resolver el reto matemático para crear un bloque.",
        "Cada 2.016 bloques (aprox. cada 2 semanas), la red ajusta automáticamente la dificultad.",
        "El **hash rate** es la cantidad de cálculos que la red puede realizar por segundo."
      ],
      "bluepoints": [
        "Mayor dificultad = más potencia necesaria",
        "Mayor hash rate = red más segura",
        "La red se regula sola para mantener el tiempo de bloque en 10 minutos"
      ],
      "image": "hash_rate_dificultad_bitcoin.png"
    },
    {
      "heading": "Factores que determinan la rentabilidad de la minería",
      "text": [
        "La rentabilidad de minar Bitcoin depende de varios factores:"
      ],
      "list": [
        "Potencia del equipo (ASIC)",
        "Dificultad de la red",
        "Precio del bitcoin",
        "Coste eléctrico y de refrigeración",
        "Cantidad de mineros compitiendo"
      ],
      "notes": [
        "En países con electricidad barata y clima frío, la minería puede ser rentable."
      ]
    },
    {
      "heading": "Procedimiento de minado de Bitcoin — Etapas completas",
      "text": [
        "El proceso completo de minado de un bloque sigue estas 7 etapas:"
      ],
      "list": [
           "** Transacción**: Un usuario envía bitcoin desde su wallet. La transacción pasa a estar pendiente en la red (mempool).",
           "** Compilación**: Los mineros recopilan transacciones no confirmadas y las agrupan en un bloque candidato.",
           "** Formación** :El minero construye su bloque incluyendo: hash del bloque anterior, raíz de Merkle, marca de tiempo, versión, bits y nonce.",
           "** Prueba de Trabajo (PoW)**: El minero realiza millones de cálculos probando distintos nonce hasta encontrar un hash válido (con ciertos ceros al inicio).",
           "** Transmisión** :Si un minero encuentra un hash válido, transmite su bloque para que otros nodos lo verifiquen.",
           "** Verificación**: Los nodos revisan si el bloque es legítimo, correcto y cumple las reglas de la red.",
           "**Confirmación**: El bloque se añade oficialmente a la blockchain. Cada bloque posterior es una nueva confirmación del anterior. ",
          
      ],
      "image": "proceso_mineria_7_etapas_diagrama.png"
    }
  ]
};

export default CAP_MINERIA_BITCOIN;
